exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n/*.chat-toast-customer {*/\r\n/*    margin-right: 500px;*/\r\n/*}*/\r\n/*.chat-toast-consultant{*/\r\n/*    margin-left: 500px;*/\r\n/*}*/\r\n", ""]);

// exports
